import dayjs from 'dayjs';
import { isNil } from 'lodash';

import { SHORT_MONTH_DAY_YEAR_FORMAT } from 'constants/date';

import {
  ANNOUNCEMENT_SEVERITY_LABEL_VARIANT,
  ANNOUNCEMENTS_AS_OF_PREFIX,
  AnnouncementSeverity,
} from './announcements.constants';

const formatDate = value =>
  isNil(value) ? null : dayjs(value).format(SHORT_MONTH_DAY_YEAR_FORMAT);

const getAsOfLabel = asOf => {
  if (isNil(asOf)) {
    return null;
  }

  return `${ANNOUNCEMENTS_AS_OF_PREFIX} ${dayjs(asOf).format(SHORT_MONTH_DAY_YEAR_FORMAT)}`;
};

const getSeverityLabelVariant = severity =>
  ANNOUNCEMENT_SEVERITY_LABEL_VARIANT[severity] ??
  ANNOUNCEMENT_SEVERITY_LABEL_VARIANT[AnnouncementSeverity.INFO];

const mapAnnouncement = announcement => ({
  id: announcement.id,
  title: announcement.title,
  body: announcement.body,
  severity: announcement.severity ?? AnnouncementSeverity.INFO,
  severityLabelVariant: getSeverityLabelVariant(announcement.severity),
  isImportant: announcement.severity === AnnouncementSeverity.IMPORTANT,
  effectiveFromLabel: formatDate(announcement.effectiveFrom),
  expiresAtLabel: formatDate(announcement.expiresAt),
});

/**
 * Maps the broker-announcements endpoint into the news-zone display shape. Returns
 * null when the response is missing so the reducer holds its empty state and the
 * zone shows an honest "no announcements" message instead of fabricated content.
 * @param {object|null} data - { announcements, asOf }
 * @returns {object|null}
 */
export const mapCommandCenterAnnouncements = data => {
  if (isNil(data)) {
    return null;
  }

  return {
    announcements: (data.announcements ?? []).map(mapAnnouncement),
    asOfLabel: getAsOfLabel(data.asOf),
  };
};
